import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AnexoRenovacaoBolsaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all AnexoRenovacaoBolsa
  list(params?: any): Observable<any[]> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllAnexoRenovacaoBolsa`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response.data));
  }

  // Create new AnexoRenovacaoBolsa
  public store(form: any): Observable<any> {
    const anexoRenovacaoBolsa = form;
    return this.apiService
      .post<{ object: any }>(`${this.path}/AddAnexoRenovacaoBolsa`, anexoRenovacaoBolsa)
      .pipe(map((response) => response.object));
  }

  // Update existing AnexoRenovacaoBolsa
  public update(form: FormGroup, id: string): Observable<any> {
    const anexoRenovacaoBolsa = form.value;
    return this.apiService
      .put<{ object: any }>(`${this.path}/UpdateAnexoRenovacaoBolsa/${id}`, anexoRenovacaoBolsa)
      .pipe(map((response) => response.object));
  }

  // Delete existing AnexoRenovacaoBolsa
  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteAnexoRenovacaoBolsaById/${id}`);
  }

  // Get AnexoRenovacaoBolsa by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/getAnexoRenovacaoBolsaById/${id}`)
      .pipe(map((response) => response.object));
  }
}
